// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SignInError__wrapper___1aoi7","logo":"SignInError__logo___1Bz0H","link":"SignInError__link___3Yaqj","button":"SignInError__button___-fwAl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SignInError/SignInError.scss
// module id = 1k0n
// module chunks = 0